import {
  FETCH_DESIGNATIONS,
  FETCH_DESIGNATIONS_SUCCESS,
  FETCH_DESIGNATIONS_FAILURE,
  CREATE_DESIGNATION_REQUEST,
  CREATE_DESIGNATION_SUCCESS,
  CREATE_DESIGNATION_FAILURE,
  DELETE_DESIGNATION,
  DELETE_DESIGNATION_SUCCESS,
  DELETE_DESIGNATION_FAILURE,
} from "./actionTypes";

const initialState = {
  designations: [],
  loading: false,
  error: null,
};

const designationReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_DESIGNATIONS:
    case CREATE_DESIGNATION_REQUEST:
    case DELETE_DESIGNATION:
      return {
        ...state,
        loading: true,
      };

    case FETCH_DESIGNATIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        designations: action.payload.data,
      };

    case CREATE_DESIGNATION_SUCCESS:
      return { ...state, loading: false, success:true, designationData: action.payload, error: null };

    case DELETE_DESIGNATION_SUCCESS:
      return { ...state, loading: false, success:true, deleteResponse: action.payload, error: null };

    case FETCH_DESIGNATIONS_FAILURE:
    case CREATE_DESIGNATION_FAILURE:
    case DELETE_DESIGNATION_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default designationReducer;
